import React from 'react';

interface StyleButtonProps {
  text?: string;
  id?: string;
  onClick?: (e: any) => void;
}

function StyleButton({ text, id, onClick }: StyleButtonProps) {
  return (
    <button
      id={id}
      onClick={onClick}
      className="z-40 mt-8 cursor-pointer rounded-full border-2 bg-brand px-12 py-3 text-sm font-medium text-white transition duration-300 hover:border-brand hover:bg-white hover:text-brand sm:px-24 sm:py-4"
    >
      {text}
    </button>
  );
}

export default StyleButton;
